import React from 'react';
import {useCartGoodsQuantity} from "../../model/useCartGoodsQuantity";
import styled from "styled-components";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

interface IProps {
    id: number;
}

const StyledQuantity = styled.div`
    display: flex;
    align-items: center;
`
const StyledButton = styled.button`
    width: clamp(30px, 3vw, 40px);
    height: clamp(30px, 3vw, 40px);
    display: flex;
    align-items: center;
    justify-content: center;
    //font-weight: 500;
    //font-size: 24px;
    line-height: 120%;
    //background-color: transparent;
    //border-color: transparent;
    outline: none;
    cursor: pointer;

    font-weight: var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-btn', 'font-weight')}, 500);
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-btn', 'font-size')}, 24px);
    background-color: var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-btn', 'bg-color')},
    transparent
    );
    color: var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-btn', 'text-color')},
    ${({theme}) => theme.colors.black});
    border-radius: var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-btn', 'border-radius')}, none);
    border: 1px solid var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-btn', 'border-color')}, transparent);
    &:hover{
        background-color:var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-btn', 'hover-bg-color')}, transparent);
        border-color:var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-btn', 'hover-border-color')}, transparent);

    }
`
const StyledCount = styled.span`
    width: clamp(30px, 3vw, 40px);
    height: clamp(30px, 3vw, 40px);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-value', 'text-color')}, 500);
    font-size: var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-value', 'text-color')}, 14px);
    background-color:var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-value', 'bg-color')}, ${({theme}) => theme.colors.primaryHover});
    color: var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-value', 'text-color')},${({theme}) => theme.colors.white});
    border-radius: var(${GLOBAL_STYLE_CONFIG.variable('cart-item-qty-value', 'border-radius')}, 6px);
    
   
`

const CartGoodsQuantity: React.FC<IProps> = ({id}) => {
    const {onIncriment, onDecrement, targetQuantity} = useCartGoodsQuantity(id)
    return (
        <StyledQuantity className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details-qty')}>
            <StyledButton className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details-qty-btn')}
                disabled={targetQuantity === 1} onClick={onDecrement}>-</StyledButton>
            <StyledCount className="">{targetQuantity}</StyledCount>
            <StyledButton onClick={onIncriment} className={GLOBAL_STYLE_CONFIG.splitByPrefix('cart-item-details-qty-btn')}>+</StyledButton>
        </StyledQuantity>
    );
};

export default CartGoodsQuantity;